<template>
  <div>
    <div>
      <NotificationMessage v-if="showNotification" :message="notificationMessage" :type="notificationType" :duration="5000"/>
    </div>
    <nav class="navbar navbar-expand-lg navbar-dark">
      <a class="titre navbar-brand">SIVERCOH</a>
    </nav>
    <div class="ml-5 mr-5 pb-5">
    <h4 class="titre1 mb-5 mt-4">JUSTIFICATIONS</h4>
      <div class ="container">
        <b-row>
          <b-col md="2" v-if="validSoumission === true">
            <b-button class="excell" @click.prevent="toggleModalSoumettre"><i class="fas fa-file-excel"></i></b-button>
          </b-col>

          <b-col md="3" v-if="validSoumission === true">
            <p class ="textExcell"><b-link @click.prevent="toggleModalSoumettre" style="text-decoration: underline">Soumettre un fichier au format Csv </b-link>
              afin de justifier une ou plusieurs anomalies </p>
          </b-col>

          <b-col class="searchAno" md="7" v-if="validSoumission === true">
            <p>Rechercher une ligne d'anomalie</p>
            <div>
              <form class="form-inline" style="display: block">
                <b-form-input
                  placeholder="N° d'anomalie"
                  v-model="filter"
                  debounce="200"
                  class="search"
                  type="text">
                </b-form-input>
                <b-button style=" border-color:grey" variant="light" @click.prevent="resetFilter">
                  <i class="fas fa-times"></i>
                </b-button>
                <button class="btn btn-info" @click.prevent="searchAnomalie" title="Rechercher">
                  <i class="fas fa-search"></i>
                </button>
              </form>
            </div>
          </b-col>
        </b-row>

          <ModalSoumettreFichierWithoutConnexion v-if="showModalSoumettre" @close="showModalSoumettre = false" @notification="handleNotification" class="mb-5 mt-5"></ModalSoumettreFichierWithoutConnexion>

        <div>
          <b-card  class="info-rapport pt-3 pb-3">
            <div class="titreRapport pr-2">Rapport n°{{idExecution}} - {{formatMoment(dateExecution)}}</div>
            <div>exécution du jeu <strong>{{nomJeu}}</strong> composé de <strong>{{ nbRequetesFromJeu }}</strong> requête(s)<br>par <strong>{{ nom }} {{prenom}} - {{email}}</strong><br>Schéma ciblé:
              <strong>{{ schema }}</strong>  -  Base de donnée ciblée: <strong>{{ bdd }}</strong><br>
              avec les paramètres : <br>
              <td v-for='(parametre,index) in parametres' v-bind:key="index">
                <strong>{{parametre.parametre}} : {{parametre.valeur}}</strong>
              </td>
            </div>
            <p><strong>{{ nbRequetesAno }}</strong> requête(s) en anomalie<br><strong>{{nblignesAno}}</strong> ligne(s) anomalique(s) - <strong>{{nbJustif}}</strong> justifiées - <strong>{{nbValid}}</strong> validées - <strong>{{nbRefuse}}</strong> refusée</p>
          </b-card>

          <b-modal v-model="showModalAnomalieIn" class="col-md-12 mt-2">
            <p class="anomalie">n° Anomalie : {{anomalieData.idLigneAnomalie}} - Priorité : {{anomalieData.gravite}}<br>
              Anomalie: {{anomalieData.message}}
              <ModalAnomalie
                :idExecution="idExecution"
                :anomalie="anomalie"
                :nomChamps = "nomChamps"
                class="col-md-12">
              </ModalAnomalie>
            </p>
          </b-modal>
        </div>

        <div class ="item">
          <b-col class="mb-2 mt-1 requetes">
            <div v-if="requetes.length!==0" >
              <div class="pagination mt-3">
                <b-pagination class="customPagination"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  prev-text="précédent"
                  next-text="suivant"
                  aria-controls="my-card"
                  size="sm"
                  align="right">
                </b-pagination>
              </div>
              <p align="left"
               v-for="requete in find"
               v-bind:key="requete.idRequete"
               class="mb-2">
                <RequetesInExecutionWithoutConnexion
                  :idExecution="idExecution"
                  :requete="requete"
                  class="center">
                </RequetesInExecutionWithoutConnexion>
              </p>
            </div>
            <div v-else class="other">
              Aucune requête dans ce rapport.
            </div>
          </b-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, computed} from "vue";
import http from '@/http.js'
import ModalSoumettreFichierWithoutConnexion from "@/components/RapportSansConnexion/ModalSoumettreFichierWithoutConnexion.vue"
import RequetesInExecutionWithoutConnexion from '@/components/RapportSansConnexion/RequetesInExecutionWithoutConnexion.vue'
import ModalAnomalie from '@/components/RapportSansConnexion/ModalAnomalieWithoutConnexion.vue';
import moment from 'moment';
import "moment/locale/fr";
import {useRoute} from "vue-router";
import NotificationMessage from "@/components/Notification.vue";

export default {
  name: "JustificationSansConnexion",

  components:{
    NotificationMessage,
    RequetesInExecutionWithoutConnexion,
    ModalSoumettreFichierWithoutConnexion,
    ModalAnomalie,

  },
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup({emit}) {
    const code = ref("");
    const filter = ref("");
    const parametres = ref([]);
    const nomChamps = ref([]);
    const requetes = ref([]);
    const anomalie = ref({});
    const anomalieData = ref({});
    const idExecution = ref(0);
    const dateExecution = ref("");
    const nomJeu = ref("");
    const nbRequetesFromJeu = ref(0);
    const nom = ref("");
    const prenom = ref("");
    const email = ref("");
    const bdd = ref("");
    const schema = ref("");
    const nbRequetesAno = ref(0);
    const nblignesAno = ref(0);
    const nbJustif = ref(0);
    const nbValid = ref(0);
    const nbRefuse = ref(0);
    const showModalSoumettre = ref(false);
    const showModalAnomalieIn = ref(false);
    const validSoumission = ref(true);
    const perPage = ref(20);
    const currentPage = ref(1);

    const showNotification = ref(false);
    const notificationMessage = ref("");
    const notificationType = ref("info");

    const handleNotification = ({ toastMessage, toastType }) => {
      notificationMessage.value = toastMessage;
      notificationType.value = toastType;
      showNotification.value = true;
      setTimeout(() => {
        showNotification.value = false;
      }, 5000);
    };

    const route = useRoute();

    const toggleModalSoumettre = () => {
      showModalSoumettre.value = !showModalSoumettre.value;
    };

    const resetFilter = () => {
      filter.value = "";
      showModalAnomalieIn.value = false;
    };

    const searchAnomalie = () => {
      http.searchAnomalieByRapportAndIdAnomalie(idExecution.value, filter.value).then((data) => {
        anomalieData.value = data;
      }).then(() => {
        http.getAnomaliesToJustifByIdLigne(idExecution.value, anomalieData.value.idLigneAnomalie).then((data) => {
          anomalie.value = data;
          showModalAnomalieIn.value = true;
        });
      });
    };

    const formatMoment = (date) => moment(date).format("DD/MM/YYYY - HH:mm:ss");

    const find = computed(() => {
      const page = currentPage.value > 1 ? (currentPage.value - 1) * perPage.value : 0;
      return requetes.value.slice(page, page + perPage.value);
    });

    const rows = computed(() => requetes.value.length);

    const getRapportByCode = () => {
      const code = route.params.code;
      http.getRapportByCode(code).then((data) => {
        idExecution.value = data.idExecution;
        dateExecution.value = data.dateExecution;
        nomJeu.value = data.nomJeu;
        nbRequetesFromJeu.value = data.nbRequetesFromJeu;
        schema.value = data.schema;
        nom.value = data.nom;
        prenom.value = data.prenom;
        email.value = data.email;
        bdd.value = data.bdd;
        nbRequetesAno.value = data.nbRequetesAno;
        nblignesAno.value = data.nblignesAno;
        nbJustif.value = data.nbJustif;
        nbValid.value = data.nbValid;
        nbRefuse.value = data.nbRefuse;
        parametres.value = data.parametres;
      }).then(() => {
        http.getRequetesFromExecutionOffline(idExecution.value).then((data) => {
          requetes.value = data;
        }).catch(() => {
          validSoumission.value = false;
          emit('notification',{
            showNotification : true,
            toastMessage : "Votre lien n'est plus valide, veuillez relancer le jeu de requetes",
            toastType : "danger",
          })
        });
      });
    };

    onMounted(() => {
      getRapportByCode();
    });

    return {
      code,
      filter,
      parametres,
      nomChamps,
      requetes,
      anomalie,
      anomalieData,
      idExecution,
      dateExecution,
      nomJeu,
      nbRequetesFromJeu,
      nom,
      prenom,
      email,
      bdd,
      schema,
      nbRequetesAno,
      nblignesAno,
      nbJustif,
      nbValid,
      nbRefuse,
      showModalSoumettre,
      showModalAnomalieIn,
      validSoumission,
      perPage,
      currentPage,
      toggleModalSoumettre,
      getRapportByCode,
      resetFilter,
      searchAnomalie,
      formatMoment,
      find,
      rows,
      showNotification,
      notificationMessage,
      notificationType,
      handleNotification
    };
  },
};
</script>

<style>

.titre{
  font-size: 40px !important;
  text-shadow: 4px 4px 0 rgba(255, 255, 255, 0.6);
  font-weight:600;
  letter-spacing:2px;
}
.card-body{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.titre1{
  text-align:left !important;
}
.info-rapport{
  color: white;
  text-align: left;
  background-color: #6c757d;
  margin-top: 3em;
}
.excell{
  font-size: 100px;
  text-align: left !important;
}
.textExcell{
  font-size: 15px;
  text-align: left !important;
  padding-top: 60px;
}
.pagination{
  justify-content: center;
}
.searchAno{
  padding-top: 2em;
}
.anomalie{
  font-size: 12px;
}
.nav-link1{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #00a3a6;
}
.nav-link1:hover{
  color: black !important;
}

.nav-link2{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #ed6e6c;
}
.nav-link2:hover{
  color: black !important;
}

.nav-link3{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #9dc544;
}
.nav-link3:hover{
  color: black !important;
}

.nav-link4{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #275662;
}
.nav-link4:hover{
  color: black !important;
}

</style>